<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div class="container">
  <h1 class="text-center lifedi-color">ข่าวสาร</h1> <br>
  <div class="row" *ngIf="rows">
    <div class="col-lg-3 col-md-4 col-sm-6 mb-4" *ngFor="let item of rows">
      <lifedi-card-box [routerLink]="[item.NEWS_ID]" [title]="item.NEWS_TITAL" [imageUrl]="item.NEWS_PIC"
        [content]="item.NEWS_DETAIL" [id]="item.NEWS_ID" [date]="item.NEWS_DATE" style="outline: none;">
      </lifedi-card-box>
    </div>
  </div>

  <div class="d-flex justify-content-center p-2" *ngIf="rows">
    <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [pageSize]="pageSize" (pageChange)="refresh()">
    </ngb-pagination>
  </div>

  <mat-spinner *ngIf="!rows" class="spinner-center"></mat-spinner>
</div>

<div [ngClass]="rows?.length > 0 ? '' : 'footer'">
  <lifedi-footer *ngIf="rows"></lifedi-footer>
</div>